import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '../../../../components/Button';

import React from 'react';

interface IProps {
  message: string;
  onContinue: () => void;
  onMessageChange: (event: any) => void;
  onSkip: () => void;
}

const EventMessage = ({ onSkip, onContinue, onMessageChange, message }: IProps) => {
  return (
    <div className="event-message wrapper">
      <Paper elevation={1} className="paper">
        <h4>LEAVE A NOTE</h4>

        <div className="paragraph">
          Let the event director a note like if you have tee time or playing partner preference.
        </div>

        <TextField
          className="message-area"
          autoFocus={true}
          fullWidth={true}
          multiline={true}
          value={message}
          rows={5}
          rowsMax={5}
          variant="outlined"
          onChange={onMessageChange}
        />

        <Button
          id="success-continue"
          variant="contained"
          color="primary"
          className="button button-shadow"
          onClick={onContinue}
        >
          SEND NOTE
        </Button>

        <Button color="primary" className="button" onClick={onSkip} id="success-cancel">
          CANCEL
        </Button>
      </Paper>
    </div>
  );
};

export { EventMessage };
